import { useTranslation } from 'react-i18next';
import useConfigBiogenLincConfig from './BiogenLincConfigGroup.config';

const useBiogenLincConfig = () => {
  const { t } = useTranslation();
  const {
    isVisibleOnBiogenLincConfig,
    eventPromotionalityConfig,
    prcValidationsConfig,
    isSwitzerlandSpecific,
    eventMarket,
    isCollectTextMessageUserConsentEnabled,
  } = useConfigBiogenLincConfig();

  return {
    isVisibleOnBiogenLincConfig,
    eventPromotionalityConfig,
    prcValidationsConfig,
    isSwitzerlandSpecific,
    eventMarket,
    isCollectTextMessageUserConsentEnabled,
    t,
  };
};

export default useBiogenLincConfig;
